import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from "lodash";
import DefaultLayout from '../../../components/Layout/GuestTemplate/DefaultLayout';
import {
    ContainerFullWidthCommunity,
    StepsContainer,
    StepsWrapperSteps,
    StepLine,
    Marker,
    MarkerTitle,
    MarkerText,
    TitleCriteria
} from "./Entrepreneurs.styles";
import SummaryOverview from '../../../components/Common/SummaryOverview';
import Banner from '../../../components/Common/Banner';
import { Images } from '../../../themes';
import NavigationBar from '../../../components/Common/NavigationBar';
import ProcessActions from '../../../actions/Process';

const Process = () => {
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();
    const isLoading = useSelector((state) => state.Process.isLoading);
    const dataProcess = useSelector((state) => state.Process.process);
    const dataProcessRegister = useSelector((state) => state.Process.processRegister);
    useEffect(() => {
        const dataGet = {
            type: "entrepreneur_process"
        };
        const dataGetForRegister = {
            type: "entrepreneur_process_register"
        };
        dispatch(ProcessActions.getProcess(dataGet));
        dispatch(ProcessActions.getProcessRegister(dataGetForRegister));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const listNav = [
        {
            title: t("general.What We Do"),
            isActive: false,
            path: "/homepage/entrepreneurs/what-we-do"
        },
        {
            title: t("general.Community"),
            isActive: false,
            path: "/homepage/entrepreneurs/community"
        },
        {
            title: t("general.Criteria"),
            isActive: false,
            path: "/homepage/entrepreneurs/criteria"
        },
        {
            title: t("general.Process"),
            isActive: true,
            path: "/homepage/entrepreneurs/process"
        },
        {
            title: t("general.Apply"),
            isActive: false,
            path: "/homepage/entrepreneurs/apply"
        }
    ];

    const _getDataLocalization = (dataContent, key) => {
        if (dataContent[i18n.language][key]) return dataContent[i18n.language][key];
        if (i18n.language === 'en') return dataContent.al[key];
        if (i18n.language === 'al') return dataContent.en[key];
    };

    const _renderStep = (item, index) => {
        return (
            <StepsWrapperSteps key={index}>
                <StepLine>
                    <Marker>
                        <p>{_.parseInt(index) + 1}</p>
                    </Marker>
                    <MarkerTitle className='fix-margin'>{!_.isUndefined(item[i18n.language]) ? _getDataLocalization(item, "title") : ""}</MarkerTitle>
                    <MarkerText>{!_.isUndefined(item[i18n.language]) ? _getDataLocalization(item, "description") : ""}</MarkerText>
                </StepLine>
            </StepsWrapperSteps>
        );
    };

    const _renderAllStep = () => {
        if (dataProcess.data_json) {
            const render = _.map(dataProcess.data_json, (item, index) => {
                return _renderStep(item, index);
            });
            return render;
        }
    };

    const _renderAllStepRegister = () => {
        const render = _.map(dataProcessRegister.data_json, (item, index) => {
            return _renderStep(item, index);
        });
        return render;
    };

    const _mainRender = () => {
        return (
            <div>
                <Banner
                    backgroundImg={Images.banner1}
                    title={t("homepageUser.Are you an Entrepreneur?")}
                    description={t("homepageUser.Access funds and knowledge from a rich and diverse pool of investors and consultants")}
                />
                <NavigationBar listNav={listNav} />
                <ContainerFullWidthCommunity>
                    <div className='d-flex-row'>
                        {dataProcess && (
                            <StepsContainer>
                                <TitleCriteria className="for-entrepreneurs">{t("general.Individual with a business idea")}</TitleCriteria>
                                {_renderAllStep()}
                            </StepsContainer>
                        )}
                        {dataProcessRegister && (
                            <StepsContainer>
                                <TitleCriteria className="for-entrepreneurs">{t("general.Registered startup")}</TitleCriteria>
                                {_renderAllStepRegister()}
                            </StepsContainer>
                        )}
                    </div>
                </ContainerFullWidthCommunity>
                <SummaryOverview />
            </div>
        );
    };
    return (
        <DefaultLayout
            context={_mainRender()}
            currentPage="entrepreneur"
            currentTop={true}
            isLoading={isLoading}
        />
    );
};

export default Process;
